import React, { useState } from 'react';
import styles from '../../Stock/stockStyles';
import OIMODAL from '../../../components/Modals/OI Modal';
import VolumeModal from '../../../components/Modals/VolumeModal';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CustomDataTable from '../../../components/CustomDataTable';
import { homePageOptionTradecolumns } from '../../../constants/homePageConstants';

const FirstTable = ({ date, table1Dropdown }) => {
	const history = useHistory();
	const [tableModal, setTableModal] = useState({
		OIModal: false,
		showModal: false,
		modalRowData: [],
	});

	/**  @type {import('../../../typings').IStateReducerState} */
	const { accessLevel, isMobile, loading, weekendErrors, homeFirstTable } =
		useSelector((state) => state.appReducer);

	const closeOIModal = () =>
		setTableModal({
			...tableModal,
			OIModal: false,
		});

	const closeVolumeModal = () =>
		setTableModal({
			...tableModal,
			showModal: false,
		});

	const rowClickHandler = (row, keyName) => {
		if (keyName === 'open_int')
			setTableModal((prev) => ({ ...prev, modalRowData: row, OIModal: true }));
		if (keyName === 'expiry') {
			localStorage.setItem('SYMBOL', row.usymbol);
			history.push(`/optionschain/${row.usymbol}`);
		}
		if (keyName === 'usymbol') {
			localStorage.setItem('SYMBOL', row.usymbol);
			history.push(`/stocks/${row.usymbol}`);
		}
		if (keyName === 'size' || keyName === 'volume') {
			let puttCallSplit = row.option.split('');
			let puttCallvalue = puttCallSplit[0];
			const objectToSend = {
				usymbol: row.usymbol,
				expiry: row.expiry,
				ivol: row.ivol,
				ivolchg: row.ivol_chg,
				asize: row.asize,
				ask: row.ask,
				bid: row.bid,
				bsize: row.bsize,
				open_int: row.open_int,
				option: row.option,
				price: row.price,
				volume: row.size,
				strike: row.strike,
				put_call: puttCallvalue,
			};
			setTableModal((prev) => ({
				...prev,
				modalRowData: objectToSend,
				showModal: true,
			}));
		}
	};

	return (
		<div
			style={
				isMobile
					? styles.boardModalTableContainerMobile
					: { ...styles.boardModalTableContainer, width: '98%' }
			}
		>
			{tableModal.OIModal && (
				<OIMODAL
					type='stockPage'
					isMobile={isMobile}
					showModal={tableModal.OIModal}
					ticker={tableModal.modalRowData.usymbol}
					expiration={tableModal.modalRowData.expiry}
					modalRowData={tableModal.modalRowData}
					closeOIModal={closeOIModal}
					selectedDate={date}
					accessLevel={accessLevel}
				/>
			)}
			{tableModal.showModal && (
				<VolumeModal
					type='stockPage'
					isMobile={isMobile}
					showModal={tableModal.showModal}
					modalRowData={tableModal.modalRowData}
					ticker={tableModal.modalRowData.usymbol}
					expiration={tableModal.modalRowData.expiry}
					modalDate={date}
					selectedDate={date}
					closeVolumeModal={closeVolumeModal}
					accessLevel={accessLevel}
				/>
			)}
			{isMobile && table1Dropdown === false ? (
				''
			) : (
				<div
					style={{
						maxHeight: 250,
						width: '100%',
						backgroundColor: 'f2f2f2',
					}}
				>
					<CustomDataTable
						columns={homePageOptionTradecolumns}
						rows={homeFirstTable}
						loading={loading}
						error={weekendErrors}
						clickHanlder={rowClickHandler}
					/>
				</div>
			)}
		</div>
	);
};

export default FirstTable;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/FirstTable/index.jsx